import { v2Api } from './v2Client';

function normArr(data) {
  return Array.isArray(data) ? data : [];
}

/** Sports (squash, padel, …) et formats de scoring configurables — voir
 * squash_manger_api_v2/Controllers/SportController.cs, ScoringFormatController.cs et docs/MULTISPORT.md.
 * Un ScoringFormatDto porte ses colonnes historiques, ses champs v2 bruts (null = comportement historique) et
 * `rules`, les règles effectives complètes lues par le moteur de score (`utils/scoringEngine`, `rulesFromFormat`).
 * Écriture réservée aux administrateurs. */
export const scoringFormatService = {
  listSports: () => v2Api.get('/Sport').then((r) => normArr(r.data)),
  /** `activeOnly` masque les formats supprimés encore référencés (désactivés). */
  listFormats: (sport_id, { activeOnly = false } = {}) =>
    v2Api
      .get('/ScoringFormat', {
        params: { ...(sport_id ? { sport_id } : {}), ...(activeOnly ? { active_only: true } : {}) },
      })
      .then((r) => normArr(r.data)),
  /** POST /ScoringFormat — { sport_id, name, unit_type, points_to_win, win_by_margin, units_to_win_match, … champs v2 }. */
  create: (body) => v2Api.post('/ScoringFormat', body).then((r) => r.data),
  /** POST /ScoringFormat/update — mise à jour partielle : champ absent / null = inchangé ; 0 (entier) ou "" (texte)
   * remet un champ v2 à NULL (comportement historique), `tie_break_at: 0` retire le tie-break. Renvoie le format. */
  update: (id, patch) => v2Api.post('/ScoringFormat/update', { ...patch, id }).then((r) => r.data),
  /** POST /ScoringFormat/delete — supprime le format, ou le désactive s'il est encore utilisé :
   * `{ deleted, deactivated, used_by: ['matchs'|'saisons'|'tournois'|'tableaux'|'phases'] }`. Refusé (409) pour le
   * format par défaut du sport. */
  delete: (id) => v2Api.post('/ScoringFormat/delete', { id }).then((r) => r.data),
  /** POST /ScoringFormat/set_default — format par défaut de son sport (un seul par sport, reporté sur
   * `Sport.default_scoring_format_id`). Renvoie le format. */
  setDefault: (id) => v2Api.post('/ScoringFormat/set_default', { id }).then((r) => r.data),
};
